export const timezoneMap = {
  DST: 'Pacific/Midway',
  U: 'Pacific/Kwajalein',
  HST: 'Pacific/Honolulu',
  AKDT: 'America/Anchorage',
  PDT: 'America/Los_Angeles',
  PST: 'America/Los_Angeles',
  UMST: 'America/Phoenix',
  UCST: 'America/Chicago',
  MDT: 'America/Denver',
  CAST: 'Australia/Adelaide',
  CDT: 'America/Mexico_City',
  CCST: 'America/Regina',
  SPST: 'America/Bogota',
  EST: 'Africa/Cairo',
  EDT: 'America/New_York',
  UEDT: 'America/New_York',
  VST: 'Asia/Vladivostok',
  PYT: 'America/Asuncion',
  ADT: 'Asia/Baku',
  CBST: 'America/Sao_Paulo',
  SWST: 'America/La_Paz',
  PSST: 'America/Santiago',
  NDT: 'America/St_Johns',
  ESAST: 'America/Sao_Paulo',
  AST: 'Asia/Kabul',
  SEST: 'America/Cayenne',
  GDT: 'Europe/Bucharest',
  MST: 'Asia/Magadan',
  BST: 'Asia/Dhaka',
  CVST: 'Atlantic/Cape_Verde',
  UTC: 'UTC',
  GMT: 'Europe/London',
  GST: 'Europe/London',
  WEDT: 'Europe/Berlin',
  CEDT: 'Europe/Berlin',
  RDT: 'Europe/Paris',
  WCAST: 'Africa/Lagos',
  NST: 'Asia/Kathmandu',
  MEDT: 'Asia/Beirut',
  SDT: 'Asia/Damascus',
  EEDT: 'Europe/Kiev',
  SAST: 'Asia/Bangkok',
  FDT: 'Europe/Helsinki',
  TDT: 'Europe/Istanbul',
  JDT: 'Asia/Jerusalem',
  LST: 'Africa/Tripoli',
  JST: 'Asia/Tokyo',
  KST: 'Asia/Seoul',
  EAST: 'Australia/Sydney',
  MSK: 'Europe/Moscow',
  SAMT: 'Europe/Samara',
  IDT: 'Asia/Tehran',
  GET: 'Asia/Tbilisi',
  CST: 'Asia/Shanghai',
  WAST: 'Australia/Perth',
  YEKT: 'Asia/Yekaterinburg',
  PKT: 'Asia/Karachi',
  IST: 'Asia/Kolkata',
  SLST: 'Asia/Colombo',
  NCAST: 'Asia/Almaty',
  NAST: 'Asia/Krasnoyarsk',
  MPST: 'Asia/Singapore',
  TST: 'Pacific/Tongatapu',
  UST: 'Asia/Ulaanbaatar',
  NAEST: 'Asia/Irkutsk',
  ACST: 'Australia/Darwin',
  AEST: 'Australia/Sydney',
  WPST: 'Pacific/Port_Moresby',
  YST: 'Asia/Yakutsk',
  CPST: 'Pacific/Guadalcanal',
  NZST: 'Pacific/Auckland',
  FST: 'Pacific/Fiji',
  KDT: 'Asia/Kamchatka',
  SST: 'Pacific/Apia'
};
